import {Controller} from 'stimulus';
import Rails from '@rails/ujs'

export default class extends Controller {
  static targets = ['searchInput']

  connect() {
    // A search term in the URL (e.g. from the navigation search box) runs the search on page load.
    if (this.searchInputTarget.value !== '') {
      Rails.fire(this.element, 'submit');
    }
  }

  search() {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      Rails.fire(this.element, 'submit');
    }, 300);
  }

  clear(){
    this.searchInputTarget.value = '';
  }
}
